//import React from 'react';
import { View } from 'react-native';

import TextTicker from 'react-native-text-ticker';

import ic from './ic';
import ce from './ce';

export default class myMQ { // my marquee

static Tcr = (pd) => { // ticker
  return (
    ce.c(View, {
      key: 'Tcr.root',
      style: {
        width: '100%',
        paddingLeft: ic.m(1),
        paddingRight: ic.m(1),
        ...pd.d_stlCtas,
      },
    }, 
      ce.c(TextTicker, {
        key: -1,
        style: {
          fontSize: ic.s(1),
          ...pd.d_stlPfxs,
        },
        scrollSpeed: 20,
        loop: true,
        marqueeOnMount: true,
        marqueeDelay: 0,
        repeatSpacer: 0,
      }, `${pd.pfx} ${pd.pfx} ${pd.pfx} ${pd.pfx} ${pd.pfx}`)
    )
  );
}

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
